import { ViLPRProvider } from '../shared/models';

/**
 * The search parameters for a query
 */
export interface QueriesSearchParams {
  fs_bbox?: string;
  bboxPolygon?: string;
  bboxPolygonWKB?: string; // WKB version for Fleet 3
}

/**
 * WKB hex representation of an empty polygon
 * Used as a fallback when geometry conversion fails
 */
export const EMPTY_POLYGON_WKB =
  '010300000001000000000000000000000000000000000000000000000000000000';

/**
 * Returns the bounding box for a given provider
 *
 * Due to the limitations of Flock and Vigilant, we support searching by a rectangle only.
 * Flock and Vigilant API take 2 coordinates that define the rectangle.
 * Fleet 3, Outpost and Fusus can take 4 coordinates for the verticies of the rectangle.
 *
 * @param inBbox - The bounding box to return
 * @param provider - The provider to return the bounding box for. Accepts string (backward compatibility) or ViLPRProvider enum (for SDM).
 * @returns The bounding box for the given provider
 */
export function getBoundingBox(
  inBbox: QueriesSearchParams,
  provider: string | ViLPRProvider,
): string {
  if (inBbox == null) {
    return null;
  }

  switch (provider) {
    case 'Flock':
    case ViLPRProvider.FLOCK:
    case ViLPRProvider.FLOCK_V3:
    case 'Vigilant':
    case ViLPRProvider.VIGILANT:
      return inBbox?.fs_bbox ?? null;
    case 'Outpost':
    case ViLPRProvider.AXON_VI:
      // Use WKB format for Outpost (Axon VI API)
      return inBbox?.bboxPolygonWKB ?? null;
    case 'Fusus':
    case ViLPRProvider.FUSUS:
      return inBbox?.bboxPolygon ?? null;
  }

  return null;
}
